import React from "react";

import TimeIntervalPicker from "components/TimeIntervalPicker";
import { TimeIntervalData } from "components/TimeIntervalPicker/TimeIntervalPicker";

import styles from "./NonUseTimingsDialog.module.scss";
import { Dialog, DialogPanel } from "@headlessui/react";

interface NonUseTimingsDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  nonUseTimings: TimeIntervalData[];
  setNonUseTimings: (nonUseTimings: TimeIntervalData[]) => void;
}

const NonUseTimingsDialog = ({
  open,
  setOpen,
  nonUseTimings,
  setNonUseTimings,
}: NonUseTimingsDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className={styles.dialog}
    >
      <div className={styles.backdrop}>
        <DialogPanel className={styles.panel}>
          <div className={styles.panelContent}>
            <TimeIntervalPicker
              timeIntervals={nonUseTimings}
              setTimeIntervals={setNonUseTimings}
              periodTitle="Non-Use"
            />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default NonUseTimingsDialog;
